define('lib/WindowMessageListener',['require','marionette'],function (require) {

    var Marionette = require('marionette');

    return Marionette.Object.extend({

        initialize: function () {
            jQuery(window).bind('message', _.bind(this.handleWindowMessage, this));
            jQuery(window).bind('storage', _.bind(this.handleStorageMessage, this));
        },

        handleWindowMessage: function (event) {
            this.triggerMessageEvent(event.originalEvent.data);
        },

        handleStorageMessage: function (event) {
            if (event.originalEvent.key === 'window_message') {
                if (event.originalEvent.newValue) {
                    this.triggerMessageEvent(JSON.parse(event.originalEvent.newValue));
                }
            }
        },

        triggerMessageEvent: function (data) {
            this.triggerMethod('message', data);
        }

    });

});
